/* eslint-disable import/no-deprecated */
import { cloneDate, getStartOfWeek } from '@fullstory/util/date';
import React from 'react';
import { Column, Container } from '../../legacy/Column';
import { DayView } from './DayView';
import css from './index.module.scss';

/**
 * @deprecated
 * `WeekView` renders a list of days.
 */
export const WeekView: React.FC<React.ComponentProps<typeof DayView>> = ({ date, ...rest }) => {
  const tempDate = getStartOfWeek(date);
  const days = [];
  for (let i = 0; i < 7; i++) {
    days.push(
      <Column key={i}>
        <DayView date={cloneDate(tempDate)} {...rest} />
      </Column>,
    );
    tempDate.setDate(tempDate.getDate() + 1);
  }
  return (
    <Container data-component="DeprecatedDatepickerWeekView" gapless className={css.weekContainer}>
      {days}
    </Container>
  );
};
